var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"participants-list-card card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-body"},[_c('p',[_c('strong',[_vm._v("ToDo")])])])
}]

export { render, staticRenderFns }